<template>
  <v-container fluid>
    <v-layout row justify-space-around>
      <v-flex xs8>
        <v-layout column justify-space-around>
          <div style="margin:0 auto;">
            <v-img contain height=100 width=150 :src="require('../../images/vss_employee_logo.png')"></v-img>
          </div>
          <form>
            <v-text-field
              :append-icon="showPass ? 'visibility' : 'visibility_off'"
              :type="showPass ? 'text' : 'password'"
              v-model="password"
              label="New Password"
              @click:append="showPass = !showPass"
            ></v-text-field>
            <v-text-field
              :append-icon="showPass ? 'visibility' : 'visibility_off'"
              :type="showPass ? 'text' : 'password'"
              v-model="passwordConfirmation"
              label="Password Confirmation"
              @click:append="showPass = !showPass"
              :error-messages="(password && passwordConfirmation && !passwordsMatch) ? 'The password and confirmation do no match' : '' "
            ></v-text-field>
            <v-flex align-self-end>
              <div>{{ }}</div>
              <v-btn
                :disabled="password && passwordConfirmation && !passwordsMatch"
                type="submit"
                class="no-margin-button"
                color="success"
                @click.prevent="submitPasswordReset"
              >
                <v-icon left>forward</v-icon>
                Reset Password
              </v-btn>
              <router-link :to="{ name: 'login' }">Back to Log in</router-link>
            </v-flex>
          </form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  components: {
  },
  created () {
    this.checkPasswordToken()
  },
  computed: {
    passwordsMatch () {
      if (this.password == this.passwordConfirmation) {
        return true
      }
      return false
    },
  },
  watch: {
  },
  data: function () {
    return {
      password: '',
      passwordConfirmation: '',
      showPass: false,
    }
  },
  methods: {
    checkPasswordToken () {
      axios.get(`/api/password_resets/${ this.$route.params.token }/edit`)
        .catch(error => {
          console.log('invalid token')
          this.$router.replace('/')
        })
    },
    submitPasswordReset() {
      this.$store.dispatch('userAuth/resetPassword',
        {
          token: this.$route.params.token,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        }
      )
        .then(() => {
          this.$store.dispatch('global/showSnackbarSuccess', { message: 'Your password has been reset!' })
          this.$router.push("/login")
        })
        .catch(err => {
        })
        .finally(res => {
          this.password = ''
          this.passwordConfirmation = ''
        })
    },
    fetchData () {
    },
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
